import React, { useEffect, useRef, useState } from "react";
import { signOut } from "@aws-amplify/auth";
import { configureAuth } from "../../auth/authConfig";
import { withSessionLock } from "../../auth/sessionQueue";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

const links = [
  ["/admin/dashboard", "Dashboard"],
  ["/admin/social-drafts", "Lady Liza Journal"],
  ["/admin/mail-center", "Mail Center"],
  ["/admin/featured-books", "Featured Books"],
  ["/admin/promotions", "Promotion Queue"],
  ["/admin/quests", "Circle Quests"],
];

export default function AdminLayout() {
  const leaving = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();
  const { pathname } = useLocation();
  const content = useRef(null);
  const previousPath = useRef(pathname);
  useEffect(() => {
    if (previousPath.current !== pathname) content.current?.focus();
    previousPath.current = pathname;
  }, [pathname]);
  async function leave() {
    if (leaving.current) return;
    if (!window.dispatchEvent(new Event('bookish:before-navigation', {cancelable:true}))) return;
    leaving.current = true;
    setBusy(true); setError("");
    try {
      await withSessionLock(async () => { configureAuth("admin"); await signOut(); });
      nav("/admin/login", { replace: true });
    } catch { setError("Sign-out failed. Please try again."); }
    finally { leaving.current = false; setBusy(false); }
  }
  return (
    <div className="min-h-screen bg-[#FBF7F0] text-[#3F256B]">
      <a href="#admin-content" className="sr-only focus:not-sr-only focus:block focus:p-4 focus:bg-white">Skip to content</a>
      <header className="bg-bookish-royal text-bookish-cream px-6 py-4 flex flex-wrap gap-4 items-center justify-between">
        <p className="font-serif text-xl">Bookish Circle Admin</p>
        <nav aria-label="Admin navigation" className="flex flex-wrap gap-4 text-sm">
          {links.map(([to, label]) => <NavLink key={to} to={to} onClick={event=>{if(pathname!==to&&!window.dispatchEvent(new Event('bookish:before-navigation',{cancelable:true})))event.preventDefault();}} className={({ isActive }) => `inline-flex min-h-[44px] items-center rounded-lg px-3 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${isActive ? "bg-bookish-cream text-bookish-royal font-semibold" : "hover:underline"}`}>{label}</NavLink>)}
        <button type="button" disabled={busy} onClick={leave} className="min-h-[44px] underline">{busy ? "Signing out..." : "Sign out"}</button>
        </nav>
      </header>
      <main ref={content} id="admin-content" tabIndex={-1} className="px-4 py-8 sm:px-6">{error && <p role="alert">{error}</p>}<Outlet /></main>
    </div>
  );
}
